import { Header } from "@/components/Header";
import { type MenuItem, MenuSection } from "@/components/shared/MenuSection";
import { SettingsBackLink } from "@/components/shared/SettingsBackLink";

export const ABOUT_AND_SUPPORT_ITEMS: MenuItem[] = [
    { label: "Help", href: "mailto:support@wags.com" },
    { label: "Ethos", to: "/ethos" },
    { label: "Values", to: "/values" },
    { label: "Terms of Service", to: "/terms" },
    { label: "Privacy Policy", to: "/privacy" },
];

export function SettingsSurface({
    onSignOut,
    isSignedIn,
    showHeader = false,
}: {
    onSignOut: () => void;
    isSignedIn: boolean;
    showHeader?: boolean;
}) {
    const preferences: MenuItem[] = [
        { label: "Email preferences", to: "/settings/email" },
    ];
    const account: MenuItem[] = [
        {
            label: "Login & security",
            to: "/settings/account",
        },
        { label: "Logins", to: "/settings/logins" },
    ];
    const session: MenuItem[] = [
        {
            label: "Sign out",
            muted: true,
            onClick: onSignOut,
        },
    ];

    return (
        <div className="w-full bg-maltese-white">
            {showHeader && <Header className="hidden md:block" />}

            <main className="page-container flex flex-col pt-8 pb-28 md:pt-page-top md:pb-24">
                <div className="mb-6 flex flex-col gap-4 md:mb-10">
                    <SettingsBackLink
                        to="/profile"
                        label="Profile"
                        className="md:hidden"
                    />
                    <h1 className="text-page-title text-doberman-black">
                        Settings
                    </h1>
                </div>

                <div className="flex flex-col gap-6 md:gap-8">
                    <MenuSection label="Preferences" items={preferences} />
                    <MenuSection label="Account" items={account} />
                    <MenuSection
                        label="About & support"
                        items={ABOUT_AND_SUPPORT_ITEMS}
                    />
                    {isSignedIn ? <MenuSection items={session} /> : null}
                </div>
            </main>
        </div>
    );
}
